import { render, staticRenderFns } from "./dialog-button.vue?vue&type=template&id=0d8a6b72"
import script from "./dialog-button.vue?vue&type=script&lang=js"
export * from "./dialog-button.vue?vue&type=script&lang=js"
import style0 from "./dialog-button.vue?vue&type=style&index=0&id=0d8a6b72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports